
import { Options, prop, Vue } from "vue-class-component";
import RadioButton from "primevue/radiobutton";
import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  error = prop<any>({
    required: true,
  });
}

@Options({
  emits: ["update:modelValue"],
  components: {
    RadioButton,
    ToggleV2,
  },
})
class CodType extends Vue.with(Props) {
  get tooltipCODShipmentDiscount() {
    return this.$t("clientManagement.registrationBranchForm.codType.tooltipCodShipmentDiscount").toString();
  }

  onChangeDeliveryFeeType(val: string) {
    this.modelValue.codRej.codAmountType = val;
  }

  onDFODChange(value: boolean) {
    this.modelValue.clientIsDfod = value;
  }

  formatFloat(value: string) {
    return value
      .replace(/[^0-9,.]+/g, "")
      .replace(/\.|\.,|,,|,\./g, ",")
      .replace(/,(\d+),/g, ",$1");
  }

  errorCaptionCodRejCommision = "";
  validateCodRejCommision(value: string) {
    value = value.replace(/,/g, ".");
    if (Number(value) < 0) {
      this.error.codRejCommision = true;
      this.errorCaptionCodRejCommision = this.$t("clientManagement.registrationBranchForm.codType.codFeeCannotBeZeroEmpty").toString();
    } else if (Number(value) > 100) {
      this.error.codRejCommision = true;
      this.errorCaptionCodRejCommision = this.$t("clientManagement.registrationBranchForm.codType.codFeeCannotExceed100").toString();
    } else {
      this.error.codRejCommision = false;
    }
  }

  errorCaptionCodRejShipmentDiscount = "";
  validateCodRejShipmentDiscount(value: string) {
    value = value.replace(/,/g, ".");
    if (Number(value) > 100) {
      this.error.codRejShipmentDiscount = true;
      this.errorCaptionCodRejShipmentDiscount = this.$t("clientManagement.registrationBranchForm.codType.codDiscountCannotExceed100").toString();
    } else {
      this.error.codRejShipmentDiscount = false;
      this.errorCaptionCodRejShipmentDiscount = "";
    }
  }
}
export default CodType;
